<template>
  <div class="orderby">
    <label
      for="select"
      class="select-label"
      :style="{
        color: tonal.white.white,
      }"
      @click.stop="toggleOptions"
    >
      <span>{{ selected ? selectedValue : '' }}</span>
      <arrow-icon :width="12" :height="12" :color="tonal.white.white" />
    </label>

    <div v-show="showOptions" class="options-container">
      <select
        id="select"
        ref="selectField"
        v-model="selectedValue"
        @focus="onFocus"
        @blur="onBlur"
        @change="handleSelected"
      >
        <option
          v-for="(option, index) in options.itemList"
          :key="index"
          :value="option.title"
        >
          {{ option.title }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
  import { tonal } from '@/constants/tonal'
  import { ArrowIcon } from '@/components/Icons'

  export default {
    components: { ArrowIcon },

    props: {
      options: {
        type: Object,
        default: () => {},
      },
    },

    data() {
      return {
        tonal,
        selected: null,
        selectedValue: '',
        showOptions: false,
      }
    },

    watch: {
      $route() {
        const orderByValue = this.$route.query.orderby

        this.updateSelectionBasedOnOrderby(orderByValue)
      },

      selectedValue(newVal, oldVal) {
        if (newVal !== oldVal) {
          if (this.options.key !== 'orderby') return

          this.updateRouterQuery(this.selected.value)
        }
      },
    },

    mounted() {
      const orderByValue = this.$route.query.orderby
      this.updateSelectionBasedOnOrderby(orderByValue)
    },

    methods: {
      updateRouterQuery(newOrderby) {
        this.$router.push({
          query: { ...this.$route.query, orderby: newOrderby },
        })
      },

      updateSelectionBasedOnOrderby(orderbyValue) {
        this.selected = this.options.itemList.find(
          (option) => option.value === (orderbyValue || this.options._default),
        )

        this.selectedValue = this.selected ? this.selected.title : ''
      },

      onFocus() {
        this.showOptions = true
      },

      onBlur() {
        this.showOptions = false
      },

      toggleOptions() {
        if (!this.showOptions) {
          this.showOptions = true
        } else {
          this.showOptions = false
        }

        if (this.showOptions) {
          this.$nextTick(() => {
            this.$refs.selectField.focus()
          })
        }
      },

      handleSelected(event) {
        if (event) {
          const selectedOption = this.options.itemList.find(
            (option) => option.title === event.target.value,
          )
          const index = this.options.itemList.findIndex(
            (option) => option.title === event.target.value,
          )
          const selected = { [this.options.key]: selectedOption.value }
          const title = selectedOption.title

          this.selected = selectedOption
          this.selectedValue = event.target.value

          this.$emit('selectedOrderby', { selected, title, index })
        }
      },
    },
  }
</script>

<style scoped lang="scss">
  .orderby {
    position: relative;
    text-align: end;
    font-size: 0;

    .select-label {
      font-size: 12px;
      line-height: 18px;
      padding: 0;
      display: inline-flex;
      align-items: center;
      gap: 2px;
      cursor: pointer;
    }

    select {
      position: absolute;
      top: 0;
      right: 0;
      opacity: 0;
      cursor: pointer;
    }
  }
</style>
